import styled from '@emotion/styled';
import { Button, ButtonProps } from 'antd';
import React from 'react';
import useSMSCaptcha from './hooks/useSMSCaptcha';

export interface SMSCaptchaButtonProps extends Omit<ButtonProps, 'loading' | 'onClick'> {
  /**
   * to send the sms
   * @date 2021-08-25
   * @returns {number|undefined|void} cooldown time(单位：秒，不返回默认60秒， 不需要冷却时返回0)
   */
  fetch: () => Promise<number | undefined | never>;
}
const Wrapper = styled.div`
  position: relative;
`;
const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
`;

const SMSCaptchaButton = (props: SMSCaptchaButtonProps) => {
  const { fetch, className, disabled, ...btnProps } = props;
  const { loading, cooldown, onSendSMS } = useSMSCaptcha({ fetch, disabled });

  return (
    <Wrapper className={className}>
      {cooldown > 0 && <Mask>({cooldown}s)</Mask>}
      <Button loading={loading} onClick={onSendSMS} disabled={disabled} {...btnProps} />
    </Wrapper>
  );
};
export default React.memo(SMSCaptchaButton);
